/**
 * Lightweight analytics push for the paid landing pages. Pushes a GTM/GA4
 * dataLayer event, SSR-safe (no-op on the server). Used by the paid-LP
 * components (hero, FAQ, CTA, phone) for cta_click / faq_open / phone_click.
 */
export const lpTrack = (
  event: string,
  extra: Record<string, unknown> = {}
): void => {
  if (typeof window === "undefined") return;
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ event, page: "calcular-seguro-vida-axa", ...extra });
};
